import i18n from '@shared/config/i18n';
import { actions } from './components/actions';
import { addButton } from './components/addButton';
import { item } from './components/item';
import { loader } from './components/loader';
import { marketOrderItem } from './components/marketOrderItem';
import { meta } from './components/meta';
import { modal } from './components/modal';
import {
  actionsToken,
  ChildBase,
  deleteInvocesToken,
  existedInvocesToken,
  GeneralJsonTypeBase,
  invocesToken,
  marketOrdersToken,
  newInvocesToken,
  noExistedInvocesToken,
  rootToken,
} from './defaults';

const { t } = i18n;

export const invoces: ChildBase = {
  spec: 'controls-vertical',
  token: rootToken,
  data: {},
  styles: {
    display: 'flex',
    flexDirection: 'column',
    gap: 0,
    position: 'relative',
    height: '100%',
  },
  child: [
    modal,
    loader,

    actions,

    {
      spec: 'grid',
      token: invocesToken,
      styles: {
        padding: '24px',
        maxHeight: '100%',
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        '& .button-icon .MuiButtonBase-root': { marginTop: '22px' },
      },
      data: {
        pending: 0,
        title: t('navMenu.directories.personalAccounts')!,
        value: true,
        readOnly: true,
        customData: {
          paymentTypesList: [],
          isFirstRender: true,
          addItemFunc: item.toString(),
          addMarketOrderFunc: marketOrderItem.toString(),
        },
      },
      meta,
      child: [
        {
          spec: 'controls-vertical',
          token: deleteInvocesToken,
          data: { value: [], visible: false },
          child: [],
        },

        {
          spec: 'controls-vertical',
          token: marketOrdersToken,
          data: {},
          child: [],
          styles: { gap: '8px' },
        },

        {
          spec: 'input-text',
          token: noExistedInvocesToken,
          data: {
            value: t('NoInvoicesAdded'),
            readOnly: true,
            canChangeReadonly: false,
            visible: false,
          },
        },

        {
          spec: 'controls-vertical',
          token: existedInvocesToken,
          data: {},
          child: [],
          styles: { gap: '8px' },
        },

        {
          spec: 'controls-vertical',
          token: newInvocesToken,
          child: [],
          data: {},
          styles: { gap: '8px' },
        },

        {
          spec: 'controls-vertical',
          token: actionsToken,
          data: { visible: true },
          child: [
            {
              spec: 'controls-horizontal',
              token: 'controls-horizontal',
              data: {},
              child: [addButton('add-file'), addButton('add-link')],
              styles: { display: 'flex', gap: '12px' },
            },
          ],
        },
      ],
    },
  ],
};

export const invocesJson: GeneralJsonTypeBase = {
  spec: 'controls-vertical',
  token: 'form-controls-vertical',
  data: {},
  child: [invoces],
};
